import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthService from "../services/auth.service";
import TopBar from "../components/TopBar";
import DiseaseForm from "../components/forms/DiseaseForm";

function NewDisease() {
  const navigate = useNavigate();
  const { id } = useParams();
  const back = "/veaux/" + id + "?view=health";

  useEffect(() => {
    if (!AuthService.getCurrentUser()) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <div>
      <TopBar link={back}></TopBar>
      <div className="mx-3 rounded-lg bg-white px-3 dark:bg-slate-900">
        <div className="mb-3 flex flex-col">
          <span className="mt-2 text-2xl font-bold text-stone-700 dark:text-slate-100">
            Ajouter une maladie
          </span>
          <p className="mb-3 text-sm text-stone-400 dark:text-slate-300">
            Vous pouvez ajouter une nouvelle maladie ici.
          </p>
          <DiseaseForm
            calfID={id}
            onDone={() => navigate(back)}
            onCancel={() => navigate(back)}
          />
        </div>
      </div>
    </div>
  );
}

export default NewDisease;
